(function () {
  // Skip entirely on touch/coarse-pointer devices (phones, tablets)
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var dot = document.createElement('div');
  dot.className = 'cursor-dot';
  document.body.appendChild(dot);
  document.documentElement.classList.add('custom-cursor-active');

  var hoverSelector = 'a, button, input, select, textarea, label, summary, [role="button"], [onclick], .button, .btn';
  var butterflySelector = '.js-cursor-butterfly';
  var mouseX = 0, mouseY = 0, ticking = false;

  function updateDot() {
    dot.style.left = mouseX + 'px';
    dot.style.top = mouseY + 'px';
    ticking = false;
  }

  document.addEventListener('mousemove', function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
    dot.classList.add('is-visible');
    if (!ticking) {
      requestAnimationFrame(updateDot);
      ticking = true;
    }
  }, { passive: true });

  document.addEventListener('mouseover', function (e) {
    if (e.target.closest && e.target.closest(hoverSelector)) {
      dot.classList.add('is-hovering');
    }
    if (e.target.closest && e.target.closest(butterflySelector)) {
      dot.classList.add('is-butterfly');
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (e.target.closest && e.target.closest(hoverSelector)) {
      dot.classList.remove('is-hovering');
    }
    // Only clear butterfly mode once we've actually left the tagged zone
    // (relatedTarget check avoids flicker when moving between child elements inside it).
    var butterflyZone = e.target.closest && e.target.closest(butterflySelector);
    if (butterflyZone && (!e.relatedTarget || !butterflyZone.contains(e.relatedTarget))) {
      dot.classList.remove('is-butterfly');
    }
  });

  document.addEventListener('mouseleave', function () {
    dot.classList.remove('is-visible');
  });
})();